  export enum PersonalActionTypes {
    POST_PERSONAL_DETAILS = 'POST_PERSONAL_DETAILS',
    GET_LATEST_LEADS = 'GET_LATEST_LEADS',
    SET_CUSTOMER_LEADS = 'SET_CUSTOMER_LEADS',
    GET_PERSONAL_DETAILS = 'GET_PERSONAL_DETAILS',
    UPDATE_OMT_URL = "UPDATE_OMT_URL",
    GET_LAST_STORED_VALUE = "GET_LAST_STORED_VALUE"
  }
  